'use strict';

import React from 'react';


import { withStyles } from '@material-ui/core/styles';
import { PropTypes } from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { connect }  from 'react-redux';

import {FwScene} from './FwScene'
import {flipwitFirebaseConnector} from '../platforms/flipwitFirebaseConnector'
import { platformHandler } from '../platforms/PlatformHandler'
import { languageManager } from '../utils/languageManager'
import { COLOR } from '../App/constants';

const styles = theme => ({  
	paper: {
	  	display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    height: '40%',
	    maxHeight: 480,
	    maxWidth: 480,
	    minHeight: 190,
	    width: '80%',
	    margin: theme.spacing.unit,
	    minWidth: 230,    
	    borderRadius: '10px',    
	    //padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	  },
	paperTitle: {
	    color: 'black',
	    height: '17%',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    boxShadow: '0 4px 2px -2px ' + COLOR.FLIPWIT_COLOR_2,
	    width: '100%',
	  },
	middleBoxPaper: {
	    height: '55%',
	    display: 'flex',
	    //Se hace un translate en vez de usar margin ya que
	    //el margin de arriba y abajo se calculan con el width
	    //y no con el height y eso no sirve
	    transform: 'none',
	    marginTop: '5%',
	    fontSize: '0.9em',
	    alignItems: 'center',
	    flexDirection: 'column',
	    textAlign: 'center',
	    width: '100%',
	    '@media (min-height: 700px)': {
	    	transform: 'translateY(10%)',
	    }
	  },
	  bottomBoxPaper: {
	    height: '28%',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    width: '100%',
	  },
	  button: {
	    backgroundColor: COLOR.FLIPWIT_COLOR_1,
	    color: 'white',
	    width: '80%',
	    minWidth: 100,
	    '&:hover': {
	      backgroundColor: COLOR.FLIPWIT_COLOR_2,
	     }   
	  },
	flipwitContent: {
	    height:'calc(100% - 65px)',
	    display: 'flex',    
	    justifyContent: 'center',
	    alignItems: 'center',
	    flexWrap: 'nowrap',    
	    flexDirection: 'column',     
	    width: '100%',
	  }, 
	labelTitlePaper: {
	    display: 'flex',
	    alignItems: 'inherit',
	    fontSize: '1.3em',
	    color: COLOR.FLIPWIT_COLOR_2,
	},
	linkLogout: {
	    fontSize: '1em',
	    color: '#0389f3',
	    textDecorationLine: 'underline',
	    cursor: 'pointer',
	},
});


class BlockedUser extends FwScene {
	componentDidMount() {
		platformHandler.checkTitleBarScene("BlockedUser");
	}

	onButtonPress(evt) {
	    platformHandler.openExternalURL('https://www.flipwit.com/perfil/suscripcion/');
	}

	onLogoutPress(evt) {
		//platformHandler.closeCurrentSession();
	    flipwitFirebaseConnector.signOut();
	    platformHandler.openScene("Role");
	}

	render() {

		const { classes } = this.props;
    	

    	return ( 
	    	<div className={classes.flipwitContent} ref={(child) => { this.mainDiv = child; }}>
	    		<Paper className={classes.paper}>
					<div className={classes.paperTitle}>
						<div className={classes.labelTitlePaper}>{languageManager.getLangWord("SUBSCRIPTION_END")}</div>
					</div>
					
					<div className={classes.middleBoxPaper}>
						<div>{languageManager.getLangWord("SUBSCRIPTION_DESC_END")}</div>
					</div>		

					<div className={classes.bottomBoxPaper}>
					  <Button variant="contained" className={classes.button} onClick={this.onButtonPress}>
					    {languageManager.getLangWord("RENEW_PLAN_NOW")}
					  </Button>
					</div>  

					<div className={classes.middleBoxPaper}>
						<div className={classes.linkLogout} onClick={this.onLogoutPress}>{languageManager.getLangWord("NAV_MENU.LOGOUT")}</div>
					</div>      

				</Paper>					
	    	</div>
	    );

		/*
	    return (
			<View style={styles.container}>
				<Paper elevation={4} style={styles.whiteBox}>
			        <Text style={styles.titleText}>{languageManager.getLangWord("SUBSCRIPTION_END")}</Text>
			        <Text style={styles.descText}>{languageManager.getLangWord("SUBSCRIPTION_DESC_END")}</Text>
			        <RaisedButton onPress={this.onButtonPress}>{languageManager.getLangWord("RENEW_PLAN_NOW")}</RaisedButton>
			        <Text style={styles.linkText} onPress={this.onLogoutPress}>{languageManager.getLangWord("NAV_MENU.LOGOUT")}</Text>
			    </Paper>
			</View>
	    );*/
	}
}

BlockedUser.contextTypes = {
  store: PropTypes.object
};

BlockedUser.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,
};

const mapStateToProps = state => {  	
  return {
  	language: state.containers.appReducer.language,    
  }
};


export default connect(mapStateToProps)(withStyles(styles,{ withTheme: true })(BlockedUser));



// WEBPACK FOOTER //
// ./src/containers/scenes/BlockedUser.js